import React, { useEffect, useState } from 'react';
import { Radio, Space } from 'antd';
import OnTraccrRadioGroup from '../inputs/OnTraccrRadioGroup';

export default {};

export const getSortMenu = (sortOptions,sortActive) => {
  const [sortType, setSortType] = useState(sortActive);

  useEffect(() => {
    const relevantOption = sortOptions.find((option) => option.title === sortType);
    if (relevantOption) {
      relevantOption.action();
    }
  }, [sortType, sortOptions]);

  return (
    <OnTraccrRadioGroup
      onChange={setSortType}
      value={sortType}
    >
      <Space direction="vertical" className="card-grid-sort-menu">
        {sortOptions.map(({
          title
        }) => (
          <Radio value={title} key={title}>
            <span className="card-grid-sort-menu-title">{title}</span>
          </Radio>
        ))}
      </Space>
    </OnTraccrRadioGroup>
  );
};
